import { DataServerHost } from "../../helpers/settings";

export const GetCheckListSampleUrl = (itemId: number, inline: boolean) => {
  return `https://${DataServerHost}/api/checklist/GetSampleImage?itemId=${itemId}&inline=${inline}`;
};
